import { render, staticRenderFns } from "./AlipayHKIcon.vue?vue&type=template&id=12a88685"
import script from "./AlipayHKIcon.vue?vue&type=script&lang=js"
export * from "./AlipayHKIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports